<script setup lang="ts">
const mode = import.meta.env.MODE
const isDevelopment = mode === 'development'
</script>

<template>
  <div
    v-if="isDevelopment"
    class="fixed top-0 left-1/2 -translate-x-1/2 z-[9999] px-6 py-1 text-[0.825rem] font-bold tracking-widest uppercase bg-red-600 text-white shadow-md pointer-events-none"
  >
    DEV
  </div>
</template>
